import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const solutions = [
  { title: "Real Estate CRM", desc: "Lead management, property matching, site visit scheduling, and deal tracking." },
  { title: "AI Lead Follow-up", desc: "AI agent that contacts every lead within 60 seconds via WhatsApp and call." },
  { title: "Property Portal", desc: "Custom listing website with search, filters, and virtual tour integration." },
  { title: "Marketing Automation", desc: "Automated drip campaigns, retargeting, and lead nurturing sequences." },
];

const RealEstate = () => (
  <StitchFeaturePage
    label="INDUSTRIES / REAL ESTATE"
    title="Build pipeline,"
    titleAccent="close deals."
    subtitle="CRM, AI follow-up, and growth systems built for brokers, developers, and property teams."
    features={solutions}
    ctaLabel="BUILD FOR REAL ESTATE"
  />
);

export default RealEstate;
